import React, { useContext } from 'react'

import { Button } from '@clientbase/clientbase-library'
import { useMediaQuery } from '@mui/material'

import { NegativationContext } from '../../../context'

const Recover: React.FC = () => {
  const { negativation, updateDialogRecover, updateModalDetail } =
    useContext(NegativationContext)

  const isMobile = useMediaQuery('(max-width:600px)')

  const handleOpen = () => {
    updateModalDetail((prevState) => ({ ...prevState, open: false }))
    updateDialogRecover({ open: true, uuid: negativation?.uuid })
  }

  if (negativation?.status !== 'negativated') return null

  return (
    <Button onClick={handleOpen} variantButton="primary" fullWidth={isMobile}>
      Marcar como recuperado
    </Button>
  )
}

export default Recover
